"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionElement = exports.ElementsWrapper = exports.FullGridItem = exports.sortByOrder = exports.buildRatiosGrid = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const FullGrid = (0, app_1.styled)(ui_1.Grid) `
  width: 100%;
  @media ${app_1.mobile} {
    grid-template-columns: 1fr;
  }
`;
const buildRatiosGrid = (data, type = 'row') => {
    return data
        .map((element) => {
        var _a;
        const ratio = (_a = element.control) === null || _a === void 0 ? void 0 : _a.ratio;
        return `minmax(0, ${ratio || type === 'column' ? `${ratio !== null && ratio !== void 0 ? ratio : 1}fr` : 'auto'})`;
    })
        .join(' ');
};
exports.buildRatiosGrid = buildRatiosGrid;
const sortByOrder = (el1, el2) => { var _a, _b, _c, _d; return ((_b = (_a = el1.control) === null || _a === void 0 ? void 0 : _a.order) !== null && _b !== void 0 ? _b : Infinity) - ((_d = (_c = el2.control) === null || _c === void 0 ? void 0 : _c.order) !== null && _d !== void 0 ? _d : Infinity); };
exports.sortByOrder = sortByOrder;
exports.FullGridItem = (0, app_1.styled)(ui_1.GridItem) `
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
function ElementsWrapper({ elements, type, }) {
    const gridDefinition = (0, exports.buildRatiosGrid)(elements.sort(exports.sortByOrder), type);
    return ((0, jsx_runtime_1.jsx)(FullGrid, Object.assign({}, (type === 'row'
        ? { templateRows: gridDefinition }
        : { templateColumns: gridDefinition, templateRows: 'max-content' }), { gap: "medium" }, { children: elements.sort(exports.sortByOrder).map((_a) => {
            var { id: elementId } = _a, element = __rest(_a, ["id"]);
            return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(SectionElement, { element: Object.assign({ id: elementId }, element) }) }, elementId));
        }) })));
}
exports.ElementsWrapper = ElementsWrapper;
function SectionElement({ element, }) {
    if ('type' in element) {
        return ((0, jsx_runtime_1.jsx)(exports.FullGridItem, Object.assign({ noCenter: true }, { children: primitiveRenderers[element.type](element) })));
    }
    if ('columns' in element || 'rows' in element) {
        const elements = ('columns' in element ? element.columns : element.rows);
        return ((0, jsx_runtime_1.jsx)(ElementsWrapper, { elements: elements, control: element.control, id: element.id, type: 'columns' in element ? 'column' : 'row' }));
    }
    return null;
}
exports.SectionElement = SectionElement;
